<ng-container *ngIf="!!page">
    <tt-pictures-list [page]="page">
        <tt-file-uploader ttLabelView="none" [(ttFiles)]="files" ttMultiple ttDropZone></tt-file-uploader>
        <tt-button *ngIf="files.length > 0" ttText="upload_pictures" ttIcon="far fa-arrow-from-bottom" (ttClick)="upload()" [ttLoading]="uploading"></tt-button>
        <tt-date-range
            *ngIf="page.show_dateselector === '1'"
            ttRememberId="w_pictures"
            ttLabel="date_fom_tom"
            ttLabelView="top"
            [(ttStartDate)]="page.date_fom"
            [(ttEndDate)]="page.date_tom"
            [(ttInterval)]="page.dateselector_index"
            (ttModelChange)="onDateRangeChange()"
        ></tt-date-range>
    </tt-pictures-list>

    <tt-card *ngIf="page.show_setting === '1'">
        <tt-button-settings ttWebpageName="pictures"></tt-button-settings>
    </tt-card>
</ng-container>
